import { HelpersService } from '../../../../../services/helpers.service';
import { inject, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { JobcardService } from '../../../../../services/jobcard.service';
import { PaymentService } from '../../../../../services/payment.service';
import { AppConfig } from '../../../../../app.config';
import { PartnerService } from '../../../../../services/partner.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JobcardReviewComponent } from '../jobcard-review/jobcard-review.component';
import { PosIntegrationService } from "../../../../../services/pos-integration.service";

declare var Stripe: any;
declare var Square: any;




import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

import { async } from 'rxjs';

@Component({
  selector: 'app-jobcard-invoices',
  templateUrl: './jobcard-invoices.component.html',
  styleUrls: ['./jobcard-invoices.component.scss'],
})
export class JobcardInvoicesComponent implements OnInit {
  public helpersService = inject(HelpersService);

  @Input() serviceID;
  @Input() partnerID;
  @Input() customerID;
  @Input() showHeader = true;
  @Input() allowPayment = true;
  @Input() allowRating = false;
  @Output() update = new EventEmitter();
  @Input() jobCards: any[] = [];

  public stripe: any;
  public square: any;
  public card: any;
  public elements: any;
  public loading: boolean = false;
  public loadingStripe: boolean = false;
  public busy: boolean = false;
  public error: string = '';
  public showRatingSheet = false;

  public canTheyPay: boolean = false;
  public canTheyPayViaPaystack: boolean = false;
  public canTheyPayViaSquare: boolean = false;
  public haveTheyPayed: boolean = false;
  public partnerName: string = '';
  public email: string = '';
  public currency: string = '';
  public total: number = 0.0;
  public vatInclusive = false;
  public rating: number = 0;
  public ratingFeedback: string = '';
  public ratingSubmited: boolean = false;
  public ratingServiceID: any;
  public ratingServiceLogID: any;

  public showGiftCardPayment: boolean = false;
  public giftCardCode: string = '';
  public giftCardValue: number = 0;
  public haveTheyPayedGiftCard: boolean = false;
  public toBeDelivered: boolean = false;
  public toBeCollected: boolean = false;
  public technicianName: string = '';
  public technicianPhoto: string = '';

  public totalPayments: number = 0;
  public amountDue: number = 0;

  public showLabourHeading: boolean = false;
  public showProductsHeading: boolean = false;

  public review_TrustpilotUrl: string = null;
  public review_GoogleReviewsUrl: string = null;

  public Squarecard: any;
  public appId = '';//'sandbox-sq0idb-R9oIty27bTmlWdapNEpX6A';
  public locationId = '';// 'LEBF7VH33KT6V'; 
  public showPayButton: boolean = false;
  public showInitiatePayButton: boolean = true;

  constructor(
    public jobcardService: JobcardService,
    public appConfig: AppConfig,
    public paymentService: PaymentService,
    public router: Router,
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public partnerService: PartnerService,
    private translate: TranslateService,
    private posIntegrationService: PosIntegrationService,
  ) { }

  ngOnInit() {



    //Get any Stripe callback parameters
    const payment_intent =
      this.route.snapshot.queryParamMap.get('payment_intent');
    const redirect_status =
      this.route.snapshot.queryParamMap.get('redirect_status');
    const error = this.route.snapshot.queryParamMap.get('error');

    //Get any Paystack callback parameters
    const reference = this.route.snapshot.queryParams['reference'];
    const trxref = this.route.snapshot.queryParams['trxref'];

    if (payment_intent && redirect_status) {
      this.loading = true;
      var pi_result = {
        paymentIntent: {
          id: payment_intent,
          status: redirect_status,
          error: error,
        },
      };
      this.completePayment(pi_result);
    } else if (reference && trxref) {
      this.loading = true;
      this.completePayStackPayment(reference, trxref);
    }
    else {
      this.getPatnerDataForCyclistPlatform();
    }

    document.addEventListener('DOMContentLoaded', async function () {
      if (!Square) {
        throw new Error('Square.js failed to load properly');
      }
    });


  }

  getPatnerDataForCyclistPlatform() {
    if (this.serviceID) {
      this.partnerService
        .getPartnerDataCyclistPlatform(this.serviceID)
        .subscribe((data) => {
          this.appConfig.populateDataCyclistPlatform(data);
          console.log('data');
          console.log(data);
          //Set third party review links
          this.review_TrustpilotUrl =
            data.reviewTrustPilotUrl == undefined
              ? null
              : data.reviewTrustPilotUrl;
          this.review_GoogleReviewsUrl =
            data.reviewGoogleUrl == undefined ? null : data.reviewGoogleUrl;
          //this.partnerID = data.partnerID;
          this.posIntegrationService.getPartnerPOSConfiguration(this.partnerID).subscribe((result) => {
            this.appId = result && result.ClientID ? result.ClientID : this.appId;
            this.locationId = result && result.LocationID ? result.LocationID : this.locationId;
          });

          if (!this.jobCards || this.jobCards.length == 0) {
            this.fetchJobcard();
          }else{
            this.updateVariablesFromJobCards(this.jobCards);
          }
        });
    }
  }

  fetchJobcard() {
    if (this.serviceID) {
      this.loading = true;
      this.totalPayments = 0;
      this.jobcardService.getFullJobCardsV1(this.serviceID, this.partnerID, this.customerID).subscribe(
        (jobCards) => {
          this.updateVariablesFromJobCards(jobCards);
        },
        (err) => {
          this.loading = false;
        },
      );
    }
  }

  updateVariablesFromJobCards(jobCards) {
    for (var i = 0; i < jobCards.length; i++) {
      jobCards[i].status = this.appConfig.getPartnerCustomStatus(
        jobCards[i].statusID,
      ); //Update status to partner status or default
    }

    console.log(jobCards);
    this.jobCards = jobCards;
    this.partnerName = this.jobCards[0].partner.partnerName;
    this.email = this.jobCards[0].email;
    this.currency = this.jobCards[0].invoice.currency;
    this.toBeDelivered = this.jobCards[0].statusID === 55;
    this.toBeCollected = this.jobCards[0].statusID === 5;
    this.vatInclusive = this.jobCards[0].partner.vatInclusive;
    this.technicianName = this.jobCards[0].technicianName;
    this.technicianPhoto = this.jobCards[0].technicianPhoto;

    this.update.emit(jobCards);
    this.total = 0;
    for (var i = 0; i < this.jobCards.length; i++) {
      this.total += this.jobCards[i].invoice.total; // - this.jobCards[i].invoice.payments;
    }

    for (var i = 0; i < this.jobCards.length; i++) {
      var canTheyPay = true;
      if (!this.jobCards[i].invoice.allowStripePayment) {
        canTheyPay = false;
        i = this.jobCards.length;
      }
      this.canTheyPay = canTheyPay;
    }

    for (var i = 0; i < this.jobCards.length; i++) {
      this.giftCardCode = this.jobCards[i].invoice.giftCardCode;
      if (
        this.jobCards[i].invoice.giftCardCode !== '' &&
        this.jobCards[i].invoice.giftCardCode !== null
      ) {
        this.haveTheyPayedGiftCard = true;
        i = this.jobCards.length;
        this.giftCardBalance();
      }
    }

    for (var i = 0; i < this.jobCards.length; i++) {
      if (this.jobCards[i].invoice.paidWithStripe || this.jobCards[i].invoice.paidWithPaystack) {
        this.haveTheyPayed = true;
        this.jobCards[i].invoice.payments =
          this.jobCards[i].invoice.total;
      }
      this.totalPayments +=
        this.jobCards[i].invoice.deposits &&
          this.jobCards[i].invoice.deposits.length > 0
          ? this.jobCards[i].invoice.deposits
            .map((x) => {
              return x.amountPaid;
            })
            .reduce((x, y) => {
              return x + y;
            })
          : 0;
    }

    for (var i = 0; i < this.jobCards.length; i++) {
      if (
        this.jobCards[i].invoice.lineItems.findIndex(
          (x) => x.isNonInventory == true,
        ) > -1
      )
        this.showLabourHeading = true;
    }
    for (var i = 0; i < this.jobCards.length; i++) {
      if (
        this.jobCards[i].invoice.lineItems.findIndex(
          (x) => x.isNonInventory == false,
        ) > -1
      )
        this.showProductsHeading = true;
    }

    this.translate.get('cyclist.rate_service', {
      partnerName: this.partnerName,
    });

    for (var i = 0; i < this.jobCards.length; i++) {
      var canTheyPayViaPaystack = true;
      if (!this.jobCards[i].invoice.allowPaystackPayment) {
        canTheyPayViaPaystack = false;
        i = this.jobCards.length;
      }
      this.canTheyPayViaPaystack = canTheyPayViaPaystack;
    }

    for (var i = 0; i < this.jobCards.length; i++) {
      var canTheyPayViaSquare = true;
      if (!this.jobCards[i].invoice.allowSquarePayment) {
        canTheyPayViaSquare = false;
        i = this.jobCards.length;
      }
      this.canTheyPayViaSquare = canTheyPayViaSquare;
    }

    this.loading = false;
    setTimeout(() => {
      if (this.canTheyPay && !this.haveTheyPayed) {
        this.createStripeCard();
      }
    }, 0);
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  createStripeCard() {
    this.loadingStripe = true;
    this.paymentService.initiateStripeConnectPayments(this.serviceID).subscribe(
      (paymentIntent) => {
        this.stripe = Stripe(this.appConfig.getStripKey(), {
          stripeAccount: paymentIntent.stripeAccountID,
        });
        this.elements = this.stripe.elements({
          clientSecret: paymentIntent.clientSecret,
        });
        this.card = this.elements.create('payment', {
          iconStyle: 'solid',
          style: {
            height: '40px',
            base: {
              iconColor: '#181818',
              color: '#181818',
              fontWeight: 500,
              fontFamily: '"Nunito Sans", "Arial", sans-serif',
              fontSize: '16px',
              fontSmoothing: 'antialiased',

              ':-webkit-autofill': {
                color: '#181818',
              },
              '::placeholder': {
                color: '#777',
              },
            },
            invalid: {
              iconColor: '#d90028',
              color: '#d90028',
            },
          },
        });
        this.card.mount('#card-input');
        setTimeout(() => {
          this.loadingStripe = false;
        }, 300);
      },
      (err) => {
        this.loadingStripe = false;
      },
    );
  }

  completePayment(pi_result) {
    console.log(pi_result);
    if (
      pi_result &&
      pi_result.paymentIntent &&
      pi_result.paymentIntent.status === 'succeeded'
    ) {
      this.paymentService
        .updateInvoiceWithStripePaymentIntentsV2(
          this.serviceID,
          pi_result.paymentIntent.id,
          pi_result.paymentIntent.amount,
        )
        .subscribe((paymentResult) => {
          this.fetchJobcard();
          this.router.navigateByUrl(
            this.router.url.indexOf('?') > -1
              ? this.router.url.split('?')[0]
              : this.router.url,
          );
          Swal.fire({
            title: 'Invoice Paid',
            text: 'Thank you for paying your invoice through Hubtiger.',
            icon: 'success',
            onClose: () => { },
          } as any);
          //todo (dcorbett) - add as any for error
          this.busy = false;
        });
    } else if (pi_result && pi_result.error) {
      this.error = pi_result.error.message;
      this.busy = false;
    } else {
      this.busy = false;
    }
  }

  submitPayment() {
    this.busy = true;
    this.stripe
      .confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: 'if_required',
      })
      .then(
        (pi_result) => {
          this.completePayment(pi_result);
        },
        (err) => {
          console.log(err);
        },
      );

    /*this.busy = true;
    this.stripe.createToken(this.card).then(card => {
      if (card.error) {
        this.busy = false;
      } else {
        console.log(card);
        console.log(this.card);
        this.paymentService.initiateStripeConnectPayments(this.serviceID).subscribe(paymentIntent => {
          console.log(paymentIntent);
          var clientSecret = paymentIntent && paymentIntent.clientSecret ? paymentIntent.clientSecret : "";
          console.log(clientSecret);
          if (clientSecret === "") {
            this.busy = false;
            //Snackbar.show({ duration: Snackbar.LENGTH_SHORT, title: strings('jobcard.payment_initiation_error') });
          } else {
            this.stripe.confirmCardPayment(clientSecret, {
              payment_method: {
                card: this.card
              },
              receipt_email: this.email
            }).then(pi_result => {
              console.log(pi_result);
              if (pi_result && pi_result.paymentIntent && pi_result.paymentIntent.status === 'succeeded') {
                this.paymentService.updateInvoiceWithStripePaymentIntents(this.serviceID, pi_result.paymentIntent.id).subscribe(paymentResult => {
                  this.fetchJobcard();
                  Swal.fire(
                    'Invoice Paid',
                    'Thank you for paying your invoice through Hubtiger.',
                    'success'
                  ).then(result => {

                  })
                })
              } else if (pi_result && pi_result.error) {
                this.error = pi_result.error.message;
                this.busy = false;
              } else {
                this.busy = false;
              }
            }, error => {
              console.log(error);
              //Alert.alert("", error && error.userInfo && error.userInfo.NSLocalizedDescription ? error.userInfo.NSLocalizedDescription : strings('jobcard.payment_initiation_error'));
              this.busy = false;
            });
          }
        }, error => {
          this.busy = false;
          //Snackbar.show({ duration: Snackbar.LENGTH_SHORT, title: strings('jobcard.payment_initiation_error') });
        });
      }
    });*/
  }

  onRate(rate) {
    //this.jobCards[id].rating = rate.newValue;
    this.rating = rate.newValue;
    this.ratingServiceID = this.jobCards[0].serviceID;
    this.ratingServiceLogID = this.jobCards[0].serviceLogID;
    //this.showRatingSheet = true;

    this.showReviewPopup();
  }

  submitRating(id) {
    this.busy = true;

    this.jobCards[id].rating = this.rating;
    this.jobCards[id].ratingFeedback = this.ratingFeedback;

    var data = {
      ServiceID: this.jobCards[id].serviceID,
      Rating: this.jobCards[id].rating,
      Feedback: this.jobCards[id].ratingFeedback,
    };
    this.jobcardService
      .postServiceRatingAnonymous(this.jobCards[id].serviceLogID, data)
      .subscribe(
        (result) => {
          this.showRatingSheet = false;
          this.rating = 0;
          this.ratingFeedback = '';
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  chargeGiftCard() {
    if (this.giftCardCode !== '') {
      this.busy = true;
      this.paymentService
        .chargeGiftCard(this.jobCards[0].partner.partnerID, {
          Code: this.giftCardCode,
          ServiceID: this.serviceID,
        })
        .subscribe((res) => {
          this.busy = false;
          this.showGiftCardPayment = false;
          this.giftCardCode = '';
          this.fetchJobcard();
        });
    }
  }

  giftCardBalance() {
    if (this.giftCardCode !== '') {
      this.busy = true;
      this.paymentService
        .giftCardBalance(this.jobCards[0].partner.partnerID, this.giftCardCode)
        .subscribe((res) => {
          this.busy = false;
          console.log(res);
          this.giftCardValue = res;
          for (var i = 0; i < this.jobCards.length; i++) {
            this.giftCardValue -= this.jobCards[i].invoice.payments;
          }
          if (this.giftCardValue < 0) this.giftCardValue = 0;
        });
    } else {
      this.giftCardValue = 0;
    }
  }

  showReviewPopup() {
    const modalRef = this.modalService.open(JobcardReviewComponent, {
      backdrop: 'static',
      windowClass: 'review-modal',
    });
    modalRef.componentInstance.serviceID = this.ratingServiceID;
    modalRef.componentInstance.serviceLogID = this.ratingServiceLogID;
    modalRef.componentInstance.rating = this.rating;
    modalRef.componentInstance.review_TrustpilotUrl = this.review_TrustpilotUrl;
    modalRef.componentInstance.review_GoogleReviewsUrl =
      this.review_GoogleReviewsUrl;
    modalRef.result.then(
      (result) => {
        if (result == true) {
          this.ratingSubmited = true;
        } else {
          this.rating = 0;
        }
      },
      (onrejected) => {
        this.rating = 0;
      },
    );
  }

  createPayStackPayment() {
    this.busy = true;
    var data = {
      ServiceID: this.serviceID,
      Amount: this.total - this.totalPayments,
      CallbackURL: window.location.href,
    }
    this.paymentService.createPaystackPaymentIntent(data).subscribe((response) => {
      if (response && response.callbackURL && response.paymentAmount > 0) {
        window.location.href = response.callbackURL;
      } else {
        this.busy = false;
      }
    }, err => {
      this.busy = false;
    });
  }

  completePayStackPayment(reference, trxref) {
    if (reference && trxref) {
      this.paymentService
        .capturePaystackPayment({
          ServiceID: this.serviceID,
          PaymentIntentId: reference
        }).subscribe((paymentResult) => {
          this.fetchJobcard();
          this.router.navigateByUrl(
            this.router.url.indexOf('?') > -1
              ? this.router.url.split('?')[0]
              : this.router.url,
          );
          Swal.fire({
            title: 'Invoice Paid',
            text: 'Thank you for paying your invoice through Hubtiger.',
            icon: 'success',
            onClose: () => { },
          } as any);
          //todo (dcorbett) - add as any for error
          this.busy = false;
        });
    } else {
      this.busy = false;
    }
  }


  async createSquarePayment() {
    this.busy = true;
    let payments;
    try {
      payments = Square.payments(this.appId, this.locationId);
    } catch {
      const statusContainer = document.getElementById(
        'payment-status-container',
      );
      statusContainer.className = 'missing-credentials';
      statusContainer.style.visibility = 'visible';
      this.busy = false;
      return;
    }

    let card;
    try {
      card = await this.initializeCard(payments);
      this.showPayButton = true;
      this.showInitiatePayButton = false;
      this.busy = false;
    } catch (e) {
      console.error('Initializing Card failed', e);
      return;
    }

  }

  async initializeCard(payments) {
    this.Squarecard = await payments.card();
    await this.Squarecard.attach('#card-container-square');

    return this.Squarecard;
  }

  async createPayment(token) {
    this.busy = true;
    var ids = [];
    for (var i = 0; i < this.jobCards.length; i++) {
      ids.push(this.jobCards[i].invoice.id);
    }
    const body = JSON.stringify({
      Amount: this.total - this.totalPayments,
      Token: token,
      InvoiceIDs: ids
    });
    console.log(body);

    await this.paymentService.postProcessPayment(body, this.partnerID.toString()).subscribe((response) => {
      if (response) {
        this.displayPaymentResults('SUCCESS');
        this.fetchJobcard();
        Swal.fire({
          title: 'Invoice Paid',
          text: 'Thank you for paying your invoice through Hubtiger.',
          icon: 'success',
          onClose: () => { },
        } as any);
        this.showPayButton = true;
        this.showInitiatePayButton = false;
        this.busy = false;
      } else {
        Swal.fire({
          title: 'There was an error while trying to process your payment',
          text: 'Please try again later.',
          icon: 'error',
          onClose: () => { },
        } as any);
      }
    },
      err => {
        this.displayPaymentResults('FAILURE');
        console.error(err);
      });
    //TODO - call your backend to make the payment
    //const paymentResponse = await fetch('/payment', {
    //  method: 'POST',
    //  headers: {
    //    'Content-Type': 'application/json',
    //  },
    //  body,
    //});

    //if (paymentResponse.ok) {
    //  return paymentResponse.json();
    //}

    //const errorBody = await paymentResponse.text();
    //throw new Error(errorBody);
  }

  // New payment flow
  async tokenize(paymentMethod) {
    const verificationDetails = {
      amount: String(this.total - this.totalPayments),
      billingContact: {
        givenName: this.jobCards[0].customer.firstName,
        familyName: this.jobCards[0].customer.lastName,
        email: this.jobCards[0].customer.email,
        phone: this.jobCards[0].customer.phone,
      },
      currencyCode: this.jobCards[0].partner.currencyCode,
      intent: 'CHARGE',
      customerInitiated: true,
      sellerKeyedIn: false,
    };
    console.log(verificationDetails);
    const tokenResult = await paymentMethod.tokenize(verificationDetails);
    if (tokenResult.status === 'OK') {
      return tokenResult.token;
    } else {
      let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
      if (tokenResult.errors) {
        errorMessage += ` and errors: ${JSON.stringify(
          tokenResult.errors,
        )}`;
      }

      throw new Error(errorMessage);
    }
  }

  // status is either SUCCESS or FAILURE;
  displayPaymentResults(status) {
    const statusContainer = document.getElementById(
      'payment-status-container',
    );
    if (status === 'SUCCESS') {
      statusContainer.classList.remove('is-failure');
      statusContainer.classList.add('is-success');
    } else {
      statusContainer.classList.remove('is-success');
      statusContainer.classList.add('is-failure');
    }

    statusContainer.style.visibility = 'visible';
  }

  async handlePaymentMethodSubmission() {
    this.busy = true;
    try {
      // disable the submit button as we await tokenization and make a payment request.
      //this.cardButton.disabled = true;
      const token = await this.tokenize(this.Squarecard);
      const paymentResults = await this.createPayment(token);
      this.displayPaymentResults('SUCCESS');

      console.debug('Payment Success', paymentResults);
    } catch (e) {
      //cardButton.disabled = false;
      this.busy = false;
      this.displayPaymentResults('FAILURE');
      console.error(e);
    }
  }


}
